/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.label.optional\":[\"Optional\"],\"checkbox-group.validation.required\":[\"At least one selection is required.\"]}");
//# sourceMappingURL=messages.mjs.map